import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-305a5c10"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "border-[1px] border-stone w-full h-5px" }

import { reactive, ref } from 'vue'
import { useEventBus } from '@vueuse/core'
import mediaRegistry from '@/assets/data/mjp/media-registry.js'
import {
  MediaLoadProgress,
  SectionChangeData,
} from '@/components/general/types'
import { MJPSection } from '@/components/magicjohnsonpark/types'
import { gsap } from 'gsap'

interface Props {
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  animationPath: string
  altText: string
  classes?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaLoader',
  props: {
    currentSection: null,
    currentSectionHasLoaded: { type: Boolean },
    animationPath: null,
    altText: null,
    classes: null
  },
  setup(__props: any) {

const props = __props as {
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  animationPath: string
  altText: string
  classes?: string
}


const element = ref(null)
const animation = ref(null)
const mediaLoadedBus = useEventBus('media-loaded')
const sectionChangedBus = useEventBus('section-changed')
const sectionLoadedBus = useEventBus('section-loaded')
const state = reactive({
  mediaLoadProgress: {},
  isFadingIn: false,
  sectionLoadProgress: 0,
  isDisplayed: false,
})

const startTransition = (useAnimation = true) => {
  if (element.value) {
    state.isFadingIn = true
    state.sectionLoadProgress = 0
    state.isDisplayed = true
    if (useAnimation) {
      gsap.to(element.value, {
        opacity: 1,
        duration: 1,
        onComplete: handleFadeInComplete,
      })
      gsap.to(animation.value, {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
      })
    }
  }
  checkLoadProgress()
}

const handleFadeInComplete = () => {
  state.isFadingIn = false
  checkLoadProgress()
}

const endTransition = () => {
  gsap.to(element.value, {
    opacity: 0,
    duration: 1,
    delay: 0.5,
    ease: 'power4.inOut',
    onComplete: () => {
      state.isDisplayed = false
    },
  })
  gsap.to(animation.value, {
    opacity: 0,
    delay: 0.5,
    duration: 0.5,
  })
}

sectionChangedBus.on((sectionInfo: unknown) => {
  const sectionInfoProxy = sectionInfo as SectionChangeData
  if (sectionInfoProxy.lastSection != sectionInfoProxy.section) {
    startTransition(
      sectionInfoProxy.section != MJPSection.Settings &&
        sectionInfoProxy.lastSection != MJPSection.Settings
    )
  }
})

const checkLoadProgress = () => {
  /* console.log(
    'load progress: ',
    props.currentSectionHasLoaded,
    state.sectionLoadProgress
  ) */
  state.sectionLoadProgress = sectionLoadProgress()
  if (!props.currentSectionHasLoaded && state.sectionLoadProgress == 1) {
    sectionLoadedBus.emit()
    endTransition()
  }
}

mediaLoadedBus.on((mediaInfo: unknown) => {
  const mediaInfoProxy = mediaInfo as MediaLoadProgress
  //console.log('media loaded', mediaInfoProxy)
  if (!state.mediaLoadProgress[props.currentSection]) {
    state.mediaLoadProgress[props.currentSection] = {}
  }
  state.mediaLoadProgress[props.currentSection][mediaInfoProxy.id] =
    mediaInfoProxy.progress
  state.sectionLoadProgress = sectionLoadProgress()
  // don't check load progress until we're done fading in
  if (!state.isFadingIn) {
    checkLoadProgress()
  }
})

const sectionLoadProgress = () => {
  let progress = 0
  let maxProgress = mediaRegistry[props.currentSection]?.length
  if (state.mediaLoadProgress[props.currentSection]) {
    for (let id in state.mediaLoadProgress[props.currentSection]) {
      progress += state.mediaLoadProgress[props.currentSection][id]
    }
  }
  return progress == maxProgress || maxProgress == 0
    ? 1
    : Math.min(1, progress / maxProgress)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: _normalizeClass(["absolute left-0 top-0 p-20 w-full h-full bg-slateGray pointer-events-none flex items-center justify-center", {
      invisible: !state.isDisplayed,
    }])
  }, [
    _createElementVNode("div", {
      ref_key: "animation",
      ref: animation,
      class: _normalizeClass(props.classes)
    }, [
      _createElementVNode("img", {
        src: props.animationPath,
        alt: props.altText
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "media-progress bg-stone h-full",
          style: _normalizeStyle({
            width: `${state.sectionLoadProgress * 100}%`,
          })
        }, null, 4)
      ])
    ], 2)
  ], 2))
}
}

})